export type AICapabilityStatus = 'available' | 'coming_soon';
export type AICapabilityCode =
  | 'collections_recommendation'
  | 'voucher_ocr'
  | 'marketplace_guided_search'
  | 'smart_filter'
  | 'predictive_scoring'
  | 'next_best_action';

export interface AICapability {
  code: AICapabilityCode;
  status: AICapabilityStatus;
  titleKey: string;
  descriptionKey: string;
  proofKey: string;
  impactKey: string;
}

export const aiCapabilities: AICapability[] = [
  {
    code: 'marketplace_guided_search',
    status: 'coming_soon',
    titleKey: 'ai:capabilities.marketplace_guided_search.title',
    descriptionKey: 'ai:capabilities.marketplace_guided_search.description',
    proofKey: 'ai:capabilities.marketplace_guided_search.proof',
    impactKey: 'ai:capabilities.marketplace_guided_search.impact',
  },
  {
    code: 'collections_recommendation',
    status: 'available',
    titleKey: 'ai:capabilities.collections_recommendation.title',
    descriptionKey: 'ai:capabilities.collections_recommendation.description',
    proofKey: 'ai:capabilities.collections_recommendation.proof',
    impactKey: 'ai:capabilities.collections_recommendation.impact',
  },
  {
    code: 'voucher_ocr',
    status: 'available',
    titleKey: 'ai:capabilities.voucher_ocr.title',
    descriptionKey: 'ai:capabilities.voucher_ocr.description',
    proofKey: 'ai:capabilities.voucher_ocr.proof',
    impactKey: 'ai:capabilities.voucher_ocr.impact',
  },
  {
    code: 'smart_filter',
    status: 'available',
    titleKey: 'ai:capabilities.smart_filter.title',
    descriptionKey: 'ai:capabilities.smart_filter.description',
    proofKey: 'ai:capabilities.smart_filter.proof',
    impactKey: 'ai:capabilities.smart_filter.impact',
  },
  {
    code: 'predictive_scoring',
    status: 'available',
    titleKey: 'ai:capabilities.predictive_scoring.title',
    descriptionKey: 'ai:capabilities.predictive_scoring.description',
    proofKey: 'ai:capabilities.predictive_scoring.proof',
    impactKey: 'ai:capabilities.predictive_scoring.impact',
  },
  {
    code: 'next_best_action',
    status: 'available',
    titleKey: 'ai:capabilities.next_best_action.title',
    descriptionKey: 'ai:capabilities.next_best_action.description',
    proofKey: 'ai:capabilities.next_best_action.proof',
    impactKey: 'ai:capabilities.next_best_action.impact',
  },
];

export function getAvailableAICapabilities(): AICapability[] {
  return aiCapabilities.filter(
    (capability) => capability.status === 'available'
  );
}
